//사원 관리
import EmpManagementContainer from './Emp/EmpManagementContainer';

export const GroupIndex = {
  EmpManagementContainer,
};
